import React from 'react';
import Header from '../components/Header';
import './EjerciciosRespiracionScreen.css';
import { logEvent } from '../analytics';

const opciones = [
  { emoji: '😕', texto: 'Siento que mi pareja\nno me escucha' },
  { emoji: '🚫', texto: 'Me cueste poner\nlimites en el trabajo' },
  { emoji: '😠', texto: 'No sé cómo hablar de lo que me molesta sin sonar agresivo' },
  { emoji: '👪', texto: 'Quiero hablar mejor\ncon mi familia' },
];

const EjerciciosRespiracionScreen = () => {
  return (
    <div className="ejercicios-bg">
      <Header />
      <div className="ejercicios-container">
        <h1 className="ejercicios-title">
          ¿En qué puedo ayudarte hoy?
        </h1>
        <div className="opciones-ayuda-lista">
          {opciones.map((op, idx) => (
            <button
              key={idx}
              className="opcion-ayuda-btn"
              onClick={() => logEvent('Breathing Exercise', 'Select Option', op.texto)}
            >
              <span className="opcion-ayuda-emoji">{op.emoji}</span>
              <span className="opcion-ayuda-texto">{op.texto}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EjerciciosRespiracionScreen; 